import validator from 'validator'

export class Validators {

    static required(errorMsg) {
        return value => {

            if (('' + value).trim().length === 0)
                return !!errorMsg ? errorMsg : 'Este campo é obrigatório.'

            return null
        }
    }


    static minLengthValidator(length, errorMsg) {
        return value => {
            if (value.length < length) {
                if (!!errorMsg) return errorMsg

                return 'Este campo deve ter no mínimo ' + length + ' caracteres.'
            }

            return null
        }
    }


    static cpf(errorMsg) {
        return value => {
            const error = errorMsg || 'CPF inválido'
            const val = (value + '').replace(/[.-]/g, '')
            //console.log(val)

            let sum = 0
            let remainder
            sum = 0
            if (val == '00000000000')
                return error

            for (let i = 1; i <= 9; i++) sum = sum + parseInt(val.substring(i - 1, i)) * (11 - i)
            remainder = (sum * 10) % 11

            if (remainder == 10 || remainder == 11) remainder = 0
            if (remainder != parseInt(val.substring(9, 10)))
                return error

            sum = 0
            for (let i = 1; i <= 10; i++) sum = sum + parseInt(val.substring(i - 1, i)) * (12 - i)
            remainder = (sum * 10) % 11

            if (remainder == 10 || remainder == 11) remainder = 0
            if (remainder != parseInt(val.substring(10, 11)))
                return error

            return null
        }
    }


    static cnpj(errorMsg) {
        return value => {
            const error = errorMsg || 'CNPJ inválido'

            const b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
            const val = (value + '').replace(/[^\d]/g, '')

            if (val.length != 14) return error

            if (/0{14}/.test(val)) return error

            for (var i = 0, n = 0; i < 12; n += val[i] * b[++i]) ;
            if (val[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return error

            for (var i = 0, n = 0; i <= 12; n += val[i] * b[i++]) ;
            if (val[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return error

            return null
        }
    }


    static cpfOrCnpj(errorMsg) {
        return value => {
            const invalidCpf = Validators.cpf(errorMsg)(value)
            const invalidCnpj = Validators.cnpj(errorMsg)(value)

            if (!!invalidCpf && !!invalidCnpj)
                return 'Campo com formato inválido'

            return null
        }


    }


    static email(email, errorMsg) {
        return value => {


            if (validator.isEmail(value + ''))
                return null

            return !!errorMsg ? errorMsg : 'E-mail inválido.'
        }
    }


    static phone(errorMsg) {
        return value => {
            const phoneNumbers = (value || '').replace(/[^0-9]/g, '')
            const number = phoneNumbers.substring(2, phoneNumbers.length)

            const countNumbers = (value || '').replace(/[^0-9]/g, '').length
            let isValid = true
            const dddList = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '21', '22', '24', '27', '28', '31',
                '32', '33', '34', '35', '37', '38', '41', '42', '43', '44', '45', '46', '47', '48', '49', '51', '53',
                '54', '55', '61', '62', '63', '64', '65', '66', '67', '68', '69', '71', '73', '74', '75', '77', '79',
                '81', '82', '83', '84', '85', '86', '87', '88', '89', '91', '92', '93', '94', '95', '96', '97', '98', '99']


            const validDDD = dddList.find(function(element) {
                return element === phoneNumbers.substring(0, 2)
            })

            if(countNumbers > 0) {
                isValid = validDDD &&
                          phoneNumbers.substring(2, 1).replace(/[^1-9]/g, '').length > 0 &&
                          number.charAt(0) != '0'
            }

            if ((countNumbers === 0 || countNumbers === 11 || countNumbers === 10) && isValid) return null

            return !!errorMsg ? errorMsg : 'Telefone inválido.'
        }
    }


    static cep(errorMsg) {
        return value => {
            const countNumbers = value.replace(/[^0-9]/g, '').length

            if (countNumbers === '31160440'.length) return null

            return !!errorMsg ? errorMsg : 'CEP inválido.'
        }
    }

    static personName(errorMsg) {
        return value => {
            const fullName = value.split(' ')
            const o = []

            fullName.forEach(w => w.split(' ').forEach(e => o.push(e.length)));

            if (o.length > 1 && !(o.includes(0) || o.includes(1)))
                return null

            return !!errorMsg ? errorMsg : 'Insira o nome e o sobrenome.';
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/_common/_form/Validators/index.js